import React from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import styles from './orderItem.module.css'
import { Link } from 'react-router-dom'
import { formatToPrice } from '../../../utility/prettifynumber'

type Props = {
  orderNumber: string
  orderId: string
  date: string
  price: number
}

function OrderItem({ orderNumber, orderId, date, price }: Props) {
  return (
    <Col xs={12} className={`${styles.orderItemCard}`} data-testid="orderItem">
      <Row className="py-3" noGutters={true}>
        <Col xs={8} className="align-self-center">
          <h4 className={`${styles.removePadding} pb-1`}>
            Order #: {orderNumber}
          </h4>
          <p className={`${styles.removePadding} pb-1`}>{date}</p>
          <p className={`${styles.removePadding}`}>{formatToPrice(price)}</p>
        </Col>
        <Col className="d-flex align-self-center  align-items-end flex-column">
          <Link to={`/orders/${orderId}`} data-testid="orderLink">
            <Button
              variant="secondary"
              size="sm"
              className={`${styles.removeMargin}`}
            >
              View Order
            </Button>
          </Link>
        </Col>
      </Row>
    </Col>
  )
}

export default OrderItem
